const getQueryArgs = (url) => {
  const qs = url.length > 0 ? url.substring(url.indexOf("?")).substr(1) : "";
  const args = {};
  const items = qs.length ? qs.split("&") : [];
  let item = null;
  let name = null;
  let value = null;
  const len = items.length;

  for (let i = 0; i < len; i++) {
    item = items[i].split("=");
    name = decodeURIComponent(item[0]);
    value = decodeURIComponent(item[1]);
    if (name.length) {
      args[name] = value;
    }
  }
  return args;
};

function debounce(func, delay = 300) {
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}

/**
 * 使用key深层次访问对象
 * @param {Object} obj 对象
 * @param {String} key 属性名
 * @example deepDotAccessObj({a:{b:'1'}}, 'a.b') -> 1
 */
function deepDotAccessObj(obj, key) {
  return key.split(".").reduce((o, i) => o && o[i], obj);
}

export { debounce, deepDotAccessObj, getQueryArgs };

